const priceFormatter = new Intl.NumberFormat(global.dataInit.culture, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
})

export default class {
  constructor (model) {
    this.id = model.id
    this.name = model.name
    this.price = model.price
  }

  get color () {
    switch (this.name.toLowerCase()) {
      case 'quartz':
        return '#f3adb0'

      case 'cristal':
        return '#a0c8dd'

      case 'rubis':
        return '#b64873'

      case 'saphir':
        return '#2e7890'

      case 'diamant':
        return '#8e8f8f'

      case 'gold':
        return '#a69474'

      case 'emeraude':
        return '#149a75'

      default:
        return '#ccc'
    }
  }

  get formatedPrice () {
    return priceFormatter.format(this.price)
  }
}
